import { GenericStatusByCall } from '../../enums/status-by-call';
import { AccountCloseoutResponse } from '../../services/closeout/types';

export interface CloseoutState {
  error: any;
  errorsLog: string[];
  statusByCall: GenericStatusByCall<CloseoutCall>;
  accountStatusData: AccountCloseoutResponse;

  // SSE Connection state
  sseConnected: boolean;
  sseError: string | null;

  // SSE Event state
  profitTargetReached: boolean;
  isTradingPlanCompleted: boolean;
  isDailyAutoClose: boolean;
}

export enum CloseoutCall {
  getAccountCloseoutStatus,
}
